import accessibilityOffIcon from '@/assets/icons/accessibility_off.svg';
import accessibilityOnIcon from '@/assets/icons/accessibility_on.svg';
import accountIcon from '@/assets/icons/account.svg';
import addIcon from '@/assets/icons/add.svg';
import addFileIcon from '@/assets/icons/add_file.svg';
import addingFileFailedIcon from '@/assets/icons/adding_file_failed.svg';
import alarmPlusIcon from '@/assets/icons/alarm_plus.svg';
import alertIcon from '@/assets/icons/alert.svg';
import arrow_inBoxLeftIcon from '@/assets/icons/arrow__in_box_left.svg';
import arrowBackIcon from '@/assets/icons/arrow_back.svg';
import arrowDropDownIcon from '@/assets/icons/arrow_drop_down.svg';
import arrowDropUpIcon from '@/assets/icons/arrow_drop_up.svg';
import arrowForwardIcon from '@/assets/icons/arrow_forward.svg';
import arrowInBoxIcon from '@/assets/icons/arrow_in_box.svg';
import arrowLeftIcon from '@/assets/icons/arrow_left.svg';
import arrowRightIcon from '@/assets/icons/arrow_right.svg';
import attachIcon from '@/assets/icons/attach.svg';
import attentionIcon from '@/assets/icons/attention.svg';
import backspaceIcon from '@/assets/icons/backspace.svg';
import buttonSpinIcon from '@/assets/icons/button_spin.svg';
import calendarIcon from '@/assets/icons/calendar.svg';
import chatIcon from '@/assets/icons/chat.svg';
import checkIcon from '@/assets/icons/check.svg';
import checkAllIcon from '@/assets/icons/check_all.svg';
import checkCircleIcon from '@/assets/icons/check_circle.svg';
import chevronDownIcon from '@/assets/icons/chevron_down.svg';
import chevronLeftIcon from '@/assets/icons/chevron_left.svg';
import chevronRightIcon from '@/assets/icons/chevron_right.svg';
import chevronUpIcon from '@/assets/icons/chevron_up.svg';
import clearAllIcon from '@/assets/icons/clear_all.svg';
import closeIcon from '@/assets/icons/close.svg';
import contactMailIcon from '@/assets/icons/contact_mail.svg';
import contrastIcon from '@/assets/icons/contrast.svg';
import deafSupportIcon from '@/assets/icons/deaf_support.svg';
import dealIcon from '@/assets/icons/deal.svg';
import deleteIcon from '@/assets/icons/delete.svg';
import documentManagementSystemIcon from '@/assets/icons/document_management_system.svg';
import downloadIcon from '@/assets/icons/download.svg';
import downloadAppStoreIcon from '@/assets/icons/download_app_store.svg';
import downloadGooglePlayIcon from '@/assets/icons/download_google_play.svg';
import draftIcon from '@/assets/icons/draft.svg';
import draftProcessIcon from '@/assets/icons/draft_process.svg';
import driverCabinetIcon from '@/assets/icons/driver_cabinet.svg';
import evgLogoIcon from '@/assets/icons/evg_logo.svg';
import exitIcon from '@/assets/icons/exit.svg';
import exportIcon from '@/assets/icons/export.svg';
import faceIdIcon from '@/assets/icons/face_id.svg';
import facebookIcon from '@/assets/icons/facebook.svg';
import facilityIcon from '@/assets/icons/facility.svg';
import fileAddedIcon from '@/assets/icons/file_added.svg';
import filterListIcon from '@/assets/icons/filter_list.svg';
import firstPageIcon from '@/assets/icons/first_page.svg';
import gmailIcon from '@/assets/icons/gmail.svg';
import goOutIcon from '@/assets/icons/go_out.svg';
import govUaLogoIcon from '@/assets/icons/gov-ua-logo.svg';
import hiIcon from '@/assets/icons/hi.svg';
import homeHarasmentOppositionIcon from '@/assets/icons/home_harasment_opposition.svg';
import infoIcon from '@/assets/icons/info.svg';
import lastPageIcon from '@/assets/icons/last_page.svg';
import likeIcon from '@/assets/icons/like.svg';
import logoMvsIcon from '@/assets/icons/logo_mvs.svg';
import logoTrizubIcon from '@/assets/icons/logo_trizub.svg';
import mailIcon from '@/assets/icons/mail.svg';
import minusIcon from '@/assets/icons/minus.svg';
import mobileMenuIcon from '@/assets/icons/mobile_menu.svg';
import moreHorizIcon from '@/assets/icons/more_horiz.svg';
import moreVertIcon from '@/assets/icons/more_vert.svg';
import mvsLogoIcon from '@/assets/icons/mvs_logo.svg';
import noImageIcon from '@/assets/icons/no_image.svg';
import noResultIcon from '@/assets/icons/no_result.svg';
import notificationsIcon from '@/assets/icons/notifications.svg';
import paperDocIcon from '@/assets/icons/paper_doc.svg';
import patienceCabinetIcon from '@/assets/icons/patience_cabinet.svg';
import paymentIcon from '@/assets/icons/payment.svg';
import personalCardIcon from '@/assets/icons/personal_card.svg';
import phoneIcon from '@/assets/icons/phone.svg';
import pinIcon from '@/assets/icons/pin.svg';
import plusIcon from '@/assets/icons/plus.svg';
import plusCircleIcon from '@/assets/icons/plus_circle.svg';
import processErrorIcon from '@/assets/icons/process_error.svg';
import processSuccessIcon from '@/assets/icons/process_success.svg';
import processWaitingIcon from '@/assets/icons/process_waiting.svg';
import readyToSendIcon from '@/assets/icons/ready_to_send.svg';
import receiptIcon from '@/assets/icons/receipt.svg';
import refusalIcon from '@/assets/icons/refusal.svg';
import searchIcon from '@/assets/icons/search.svg';
import sendIcon from '@/assets/icons/send.svg';
import settingsIcon from '@/assets/icons/settings.svg';
import smartphoneIcon from '@/assets/icons/smartphone.svg';
import starIcon from '@/assets/icons/star.svg';
import starBorderIcon from '@/assets/icons/star_border.svg';
import subdirectoryArrowRightIcon from '@/assets/icons/subdirectory_arrow_right.svg';
import supervisorAccountIcon from '@/assets/icons/supervisor_account.svg';
import thumbUpIcon from '@/assets/icons/thumb_up.svg';
import toRevealIcon from '@/assets/icons/to_reveal.svg';
import touchIdIcon from '@/assets/icons/touch_id.svg';
import waitingIcon from '@/assets/icons/waiting.svg';
import wantedWeaponIcon from '@/assets/icons/wanted_weapon.svg';
import xIcon from '@/assets/icons/x.svg';
import youtubeIcon from '@/assets/icons/youtube.svg';
import zoomInIcon from '@/assets/icons/zoom_in.svg';
import zoomOutIcon from '@/assets/icons/zoom_out.svg';

export const icons = {
  accessibility_off: accessibilityOffIcon,
  accessibility_on: accessibilityOnIcon,
  account: accountIcon,
  add: addIcon,
  add_file: addFileIcon,
  adding_file_failed: addingFileFailedIcon,
  alarm_plus: alarmPlusIcon,
  alert: alertIcon,
  arrow__in_box_left: arrow_inBoxLeftIcon,
  arrow_back: arrowBackIcon,
  arrow_drop_down: arrowDropDownIcon,
  arrow_drop_up: arrowDropUpIcon,
  arrow_forward: arrowForwardIcon,
  arrow_in_box: arrowInBoxIcon,
  arrow_left: arrowLeftIcon,
  arrow_right: arrowRightIcon,
  attach: attachIcon,
  attention: attentionIcon,
  backspace: backspaceIcon,
  button_spin: buttonSpinIcon,
  calendar: calendarIcon,
  chat: chatIcon,
  check: checkIcon,
  check_all: checkAllIcon,
  check_circle: checkCircleIcon,
  chevron_down: chevronDownIcon,
  chevron_left: chevronLeftIcon,
  chevron_right: chevronRightIcon,
  chevron_up: chevronUpIcon,
  clear_all: clearAllIcon,
  close: closeIcon,
  contact_mail: contactMailIcon,
  contrast: contrastIcon,
  deaf_support: deafSupportIcon,
  deal: dealIcon,
  delete: deleteIcon,
  document_management_system: documentManagementSystemIcon,
  download_app_store: downloadAppStoreIcon,
  download: downloadIcon,
  download_google_play: downloadGooglePlayIcon,
  draft: draftIcon,
  draft_process: draftProcessIcon,
  driver_cabinet: driverCabinetIcon,
  evg_logo: evgLogoIcon,
  exit: exitIcon,
  export: exportIcon,
  face_id: faceIdIcon,
  facebook: facebookIcon,
  facility: facilityIcon,
  file_added: fileAddedIcon,
  filter_list: filterListIcon,
  first_page: firstPageIcon,
  gmail: gmailIcon,
  go_out: goOutIcon,
  'gov-ua-logo': govUaLogoIcon,
  hi: hiIcon,
  home_harasment_opposition: homeHarasmentOppositionIcon,
  info: infoIcon,
  last_page: lastPageIcon,
  like: likeIcon,
  logo_mvs: logoMvsIcon,
  logo_trizub: logoTrizubIcon,
  mail: mailIcon,
  minus: minusIcon,
  mobile_menu: mobileMenuIcon,
  more_horiz: moreHorizIcon,
  more_vert: moreVertIcon,
  mvs_logo: mvsLogoIcon,
  no_image: noImageIcon,
  no_result: noResultIcon,
  notifications: notificationsIcon,
  paper_doc: paperDocIcon,
  patience_cabinet: patienceCabinetIcon,
  payment: paymentIcon,
  personal_card: personalCardIcon,
  phone: phoneIcon,
  pin: pinIcon,
  plus: plusIcon,
  plus_circle: plusCircleIcon,
  process_error: processErrorIcon,
  process_success: processSuccessIcon,
  process_waiting: processWaitingIcon,
  ready_to_send: readyToSendIcon,
  receipt: receiptIcon,
  refusal: refusalIcon,
  search: searchIcon,
  send: sendIcon,
  settings: settingsIcon,
  smartphone: smartphoneIcon,
  star: starIcon,
  star_border: starBorderIcon,
  subdirectory_arrow_right: subdirectoryArrowRightIcon,
  supervisor_account: supervisorAccountIcon,
  thumb_up: thumbUpIcon,
  to_reveal: toRevealIcon,
  touch_id: touchIdIcon,
  waiting: waitingIcon,
  wanted_weapon: wantedWeaponIcon,
  x: xIcon,
  youtube: youtubeIcon,
  zoom_in: zoomInIcon,
  zoom_out: zoomOutIcon,
};

export type IconName = keyof typeof icons;
